import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ImmomioIconName } from '@resident-nx/shared';
import { IconWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconWebComponent],
})
export class NavigationItemWebComponent {
  @Input() icon!: ImmomioIconName;
  @Input() text!: string;
  @Output() navigateTo = new EventEmitter();
}
